import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "../components/headers/Sidebar";
import { AppHeader } from "../components/headers/AppHeader";

export const AppLayout = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden bg-gray-100">

      {/* Sidebar */}
      <Sidebar
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
      />

      {/* Main */}
      <div className="flex flex-1 flex-col min-w-0">

        {/* Header */}
        <AppHeader setMobileOpen={setMobileOpen} />

        {/* Scroll only here */}
        <main className="flex-1 overflow-y-auto p-4 sm:p-6">
          <Outlet />
        </main>

      </div>
    </div>
  );
};